import { TRuleWithTheme } from 'styles/theme';

export const label: TRuleWithTheme = ({ theme }) => ({
    fontSize: '.75rem',
    color: theme.colors.textSecondary,
});
